import { render, staticRenderFns } from "./CorrectOrderSlideOptions.vue?vue&type=template&id=bde3cf8c&"
import script from "./CorrectOrderSlideOptions.vue?vue&type=script&lang=js&"
export * from "./CorrectOrderSlideOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports